module.exports = __webpack_public_path__ + "img/swiper_3.5_5_1.ed7bc715.webp";